import { usePricingEditorConnector } from './usePricingEditor.connector'
import { PricingEditorRoot } from 'common/drawers/PricingEditor/view/pricingEditor.root'
import { useCurrentInspectorAsset } from 'Cube/view/layouts/billingSchedule/BillingScheduleInspector/items/AttachmentsInspector/useCurrentInspectorAsset'
import { AttachmentPdfPreviewDrawer } from 'Assets/index'
/**
 * Route components are expected to be rendered as part of the routing definitions,
 * such as routes.tsx.
 *
 * If a route component needs access to data from the billing schedule context, it
 * should use a connector hook.
 * @returns
 */
export const PricingEditorCubeRouteWrapper = () => {
  const connector = usePricingEditorConnector()
  const { currentInspectorAsset } = useCurrentInspectorAsset()

  return (
    <PricingEditorRoot
      variant="variant"
      existingPrice={connector.existingData.price}
      existingProduct={connector.existingData.product}
      disableDefaultPricePorts={connector.disableDefaultPricePorts}
      initialMode={connector.mode}
      currency={connector.scheduleCurrency}
      variantPriceId={connector.existingData?.price?.id}
      onSave={connector.onSave}
      onCancel={connector.onCancel}
      drawerLeadingContent={
        currentInspectorAsset ? (
          <AttachmentPdfPreviewDrawer {...currentInspectorAsset} />
        ) : undefined
      }
    />
  )
}
